import React, { useState, useEffect } from "react";
import { useMaterias } from "../../hooks/adminexamen/useMaterias";
import { Card, Col, Select } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { elToast } from '../../functions/alertas';
import {
  URL_RESPUESTAS_CORRECTAS,
  URL_BACKEND
} from "../../api/url";


const useReportes = () => {


    //* variables
    const { materias } = useMaterias()
    const [ aspirantesCarreras, setAspirantesCarreras ] = useState([])
    const [ciclosExamen, setCiclosExamen] = useState([])
    const [ciclo, setCiclo] = useState('2022-2023')



    //* funciones
    const enviarReportesIndividualesPorCorreo = () => {

        // obtener la información necesaria de todos los aspirantes

        const formData = new FormData();
        formData.append("funcion", "reporteGeneralAlumnos");
        formData.append("pk_carrera", 0);

        fetch(URL_BACKEND, {
            method: "POST",
            body: formData
        })
        .then( res => res.json() )
        .then(datos => {

            console.log(datos);

            // elección de envío de correo

            let aspirantesAenviar = [];

            if (true) {

                // ENVIO DE CORREOS POR CARRERAS CHICAS

                // agrupar a todos los aspirantes por carrera
                aspirantesAenviar = datos.filter((aspirante) => {
                if (aspirante.fk_carrera == 1) {
                    return true;
                }
                });

            }else{

                // ENVIO DE CORREOS POR CARRERAS GRANDES

                // agrupar a todos los aspirantes por carrera
                const todosAspirantesPorCarrera = datos.filter((aspirante) => {

                    if ( aspirante.fk_carrera == 1 ) {
                        return true;
                    }

                })

                console.log(todosAspirantesPorCarrera);


                // NOTA: el último grupo de aspirantes a enviar será el arreglo "todosAspirantesPorCarrera", y PHP se encargará de validar los aspirantes que faltan de enviar el correo.

                // para ello se cambia el if de abajo por "false"
                // si es "true" el arreglo "todosAspirantesPorCarrera" se divide en un grupo más pequeño

                if(false){

                    // fraccionar el grupo de aspirantes a enviar
                    let i = 0;
                    while (i <= 66 ) {

                        aspirantesAenviar.push(todosAspirantesPorCarrera[i]);
                        i++;
                    }

                }else{

                    aspirantesAenviar = todosAspirantesPorCarrera;

                }

            }

            console.log(aspirantesAenviar);

            // generar los reportes PDF y enviarlos por correo con la información obtenida

            const data = {
                "funcion": "enviarReportesIndividualesPorCorreo",
                "datosAspirantes": aspirantesAenviar
            };


            fetch(URL_BACKEND, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(r => {

                console.log(r)

                if (r.codigo == 1) {

                    alert(r.mensaje);

                } else if (r.codigo == 2) {

                    alert(r.mensaje);

                } else if (r.codigo == 0) {

                    alert(r.mensaje);
                }


            })
            .catch(() => {
                // se ha alcanzado el límite de correos por iteración
                alert("Limite de correos alcanzados.");
            });

        })
        .catch(() => {alert("Error en el servidor");});

    }



    const actualizarEstadoExamenAspirantes = () => {

        // formData.append("funcion", "registrarAplicacionAspirante");
        // esta función fue para un proceso especial: registrar el número y la fecha de aplicación de los aspirantes en la BD
        // para no crear una nueva función simplemente reutilicé esta

        const formData = new FormData();

        formData.append("funcion", "actualizarEstadoExamenAspirantes");

        fetch(URL_BACKEND, {
            method: "POST",
            body: formData
        })
        .then(res => res.json())
        .then(datos => {

            console.log(datos);

        })
        .catch(() => { alert("Error en el servidor"); });

    }


    // eslint-disable-next-line
    const traerReporteRespuestasCorrectas = ( pk_materia, materia ) => {

        const nombreMateria = materia.toUpperCase();

        const body = new FormData();
        body.append( "pk_materia", pk_materia )

        fetch( URL_RESPUESTAS_CORRECTAS, {
            method: 'post',
            body
        })
        .then( r => r.blob() )
        .then( d => {
            const pdf = URL.createObjectURL(d);
            // window.open(pdf, "_blank");
            const anchor = document.createElement("a");
            anchor.download = "RESPUESTAS CORRECTAS - " + nombreMateria;
            anchor.href = pdf;
            anchor.click();
        })
        .catch( () => alert("Error al generar reporte") )

    }


    const traerCantidadAspirantesPorCarrera = () => {

        const body = new FormData()
        body.append( 'funcion', 'cantidadAspirantesPorCarrera' )
        body.append( 'ciclo', ciclo )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( r => {
            setAspirantesCarreras( r )
        })
        .catch( e => {
            elToast( 'Hay problemas al obtener la cantidad de aspirantes', 'error' )
            console.log(e);
        })

    }



    const traerCiclosExamen = () => {

        const datos = new FormData()
        datos.append('funcion', 'traerCiclosExamen');

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( setCiclosExamen )
    }



    //* piezas de ui
    const aspirantesPorCarrera = () => {

        if ( aspirantesCarreras.length > 0 ) {
            return aspirantesCarreras.map( (e, i) => (
                <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ e.carrera } style={{ marginBottom: 10 }}>

                    <Card
                        title={ e.nom_carrera }
                        size='small'
                    >
                        <UserOutlined /> { e.cantidad } aspirantes
                    </Card>

                </Col>
            ))
        } else {
            return [ 1, 2, 3, 4 ].map( (e, i) => (
                <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ i } style={{ marginBottom: 10 }}>

                    <Card
                        loading
                        size='small'
                    >
                    </Card>

                </Col>
            ))
        }

    }


    const cardMateria = () => {

        if ( materias.length > 0 ) {
            return materias.map( (e, i) => (
                <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ i } style={{ marginBottom: 10 }}>

                    <Card
                        onClick={ () => traerReporteRespuestasCorrectas( e.pk_materia, e.materia ) }
                        title={ e.materia }
                        hoverable
                    >
                        { e.cantidad } preguntas
                    </Card>

                </Col>
            ))
        } else {
            return [ 1, 2, 3, 4 ].map( (e, i) => (
                <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ i } style={{ marginBottom: 10 }}>

                    <Card
                        loading
                        hoverable
                    >
                    </Card>

                </Col>
            ))
        }

    }


    const SelectCiclo = () => (
        <>
            <p>Filtrar por año:</p>
            <Select
                size="large"
                style={{
                    width: 200,
                    marginBottom: 20
                }}
                onChange={ setCiclo }
                defaultValue={ ciclo }
            >
                { ciclosExamen.map((e, i) =>{
                    return (
                        <Select.Option key={ i } value={ e.ciclo_examen }>
                            { e.ciclo_examen }
                        </Select.Option>
                    )}) }
            </Select>
        </>
    )




    //* useEffect
    useEffect(() => {
        traerCiclosExamen()
    }, [])

    useEffect(() => {
        traerCantidadAspirantesPorCarrera()
    }, [ ciclo ])



    return {
        cardMateria,
        aspirantesPorCarrera,
        enviarReportesIndividualesPorCorreo,
        actualizarEstadoExamenAspirantes,
        SelectCiclo
    }

}

export default useReportes;